/**
 * WordPress dependencies
 */

export default {
	hookPrefix: 'testimonial-item',
	layouts: [ {
		name: 'layout-1',
		label: 'Layout 1',
		imageAlign: 'center',
		titleAlign: 'center',
		ratingAlign: 'center',
	}, {
		name: 'layout-2',
		label: 'Layout 2',
		imageAlign: 'center',
		titleAlign: 'left',
		ratingAlign: 'left',
	}, {
		name: 'layout-3',
		label: 'Layout 3',
		imageAlign: 'center',
		titleAlign: 'left',
		ratingAlign: 'left',
	} ],
};
